import pick from "lodash/pick";
export default function getUtmsAndAdditionalData(
  query,
  hasAdditionalData = true
) {
  const dadosAdicionais = pick(
    query,
    Object.keys(query).filter(item => !item.includes("utm"))
  );
  const utm = pick(
    query,
    Object.keys(query).filter(item => item.includes("utm"))
  );
  if (hasAdditionalData) utm.dadosAdicionais = dadosAdicionais;

  return utm;
}
